import React, { type FC } from 'react';

import { AppTopbar } from '@/components/blocks/topbar/app-topbar';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => (
  <div className='flex min-h-screen flex-col'>
    <AppTopbar />
    {/* clip, not auto: a scroll container here would stop sticky elements
        from sticking, and main never scrolls itself (the window does). */}
    <main className='flex flex-1 flex-col overflow-x-clip p-2'>{children}</main>
  </div>
);

export default AppLayout;
